import { type FormikProps } from "formik";
import styles from "./settingsForm.module.scss";
import ValidatedForm from "components/forms/ValidatedForm";
import { type PackSettingsView } from "../../types/state";
import { PricingSettings } from "./PricingSettings/PricingSettings";
import { LicensingSettings } from "./LicensingSettings/LicensingSettings";
import { type AutosaveProps } from "utils";
import { type PackSettingsFormProps } from "../types";
import { PricingTypes } from "enums/licensing/pricingTypes";

export type SettingsFormPropsAll = PackSettingsFormProps & FormikProps<PackSettingsView> & AutosaveProps;

const SettingsForm = (props: SettingsFormPropsAll) => {
  const {
    isLoading,
    values: { pricingTypeId },
    billingTerms,
    packTrialPeriods,
    onIsValidChange,
    hasGlobalAccess,
    hasPacksManagePermissions,
  } = props;

  const showLicensingSettings =
    pricingTypeId === PricingTypes.Free || (pricingTypeId === PricingTypes.Other && hasPacksManagePermissions);

  const renderFields = () => {
    return (
      <div className={styles.root}>
        <div className={styles["settings-fields"]}>
          <PricingSettings
            {...props}
            billingTerms={billingTerms}
            packTrialPeriods={packTrialPeriods}
            prefix="pricingSettings"
            onIsValidChange={onIsValidChange}
            hasGlobalAccess={hasGlobalAccess}
            hasPacksManagePermissions={hasPacksManagePermissions}
          />
          <div className={styles["licensing"]}>
            {showLicensingSettings && <LicensingSettings {...props} propertyNamePrefix="licensingSettings" />}
          </div>
        </div>
      </div>
    );
  };

  return (
    <ValidatedForm withoutFormik isLoading={isLoading} formWidthComputer={5} disablePreventTransitionPrompt>
      {renderFields}
    </ValidatedForm>
  );
};

export default SettingsForm;
